<template>
  <div class="menu-mov">
    <ul class="menu-mov__list">
      <li v-for="item in listMainOptions" :key="item.id" class="menu-mov__list__item">
        <router-link
          :to="item.link"
          class="menu-mov__list__item__link">
          <icono
            class="menu-mov__list__item__link__icon"
            :icon="item.icon" 
            :size="20"
            :style="{color: item.color}"></icono>
            <span class="menu-mov__list__item__link__text">{{ item.option }}</span>
        </router-link>
      </li>
      <li class="menu-mov__list__item">
        <a
          @click="changeShowMenu()"
          class="menu-mov__list__item__link">
          <icono
            class="menu-mov__list__item__link__icon"
            :icon="icon" 
            :size="20"
            :style="{color: color}"></icono>
            <span class="menu-mov__list__item__link__text">más</span>
        </a>
      </li>
    </ul>
    <ul v-if="showMenu" class="menu-right">
      <li 
        v-for="item in listaSecondaryOptions" 
        :key="item.id" 
        class="menu-right__item">
        <router-link
          :to="item.link"
          class="menu-right__item__link">
          <icono
            class="menu-right__item__link__icon"
            :icon="item.icon" 
            :size="20"
            :style="{color: item.color}"></icono>
            <span class="menu-right__item__link__text">{{ item.option }}</span>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'VMenuMov',
    props: {
      options: {
        default: [], // coleccion objetos tipo: {id,option,icon, link, color}
        type: Array
      }
    },
    computed: {
      listMainOptions: function () {
        return this.options.slice(0, 4)
      },
      listaSecondaryOptions: function () {
        return this.options.slice(4)
      }
    },
    data() {
      return {
        showMenu: false,
        icon: 'mdiMenu',
        color: '#424242',
      }
    },
    methods: {
      changeShowMenu: function () {
        this.showMenu = !this.showMenu
        if (this.showMenu) {
          this.icon = 'mdiCloseCircleOutline'
          this.color = '#e74c3c'
        } else {
          this.icon = 'mdiMenu'
          this.color = '#424242'
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
  .menu-mov {
    border-top: 1px solid $color-8;
    position: fixed;
    width: 100%;
    bottom: 0;
    display: flex;
    background: $color-8;
    padding: 0px;
    margin: 0px;
    border-radius: 10px;
    overflow-x: hidden;
    z-index: 1000;
    @include desde($medium) {
      bottom: 0;
    }
    @include desde($large) {
      display: none;
    }
    &__list {
      display: flex;
      width: 100%;
      justify-content: space-between;
      list-style: none;
      padding-left: 1em;
      padding-right: 1em;
      margin: 0px;
      &__item {
        display: block;
        width: 100%;
        text-align: center;
        &:first-child a {
          color: $color-6;
          font-weight: bold;
        }
        &__link {
          display: flex;
          width: 100%;
          padding: 10px 5px;
          text-decoration: none;
          color: $color-1;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          @include desde($medium) {
            padding: 10px;
          }
          &__icon {
            margin-bottom: -10px;
          }
          &__text {
            display: block;
            margin-top: 5px;
            font-size: 12px;
            width: 60px; 
            white-space: nowrap;
            overflow: hidden; 
            text-overflow: ellipsis;
            text-align: center;
            text-transform: capitalize;
            @include desde($medium) {
              font-size: 14px;
              width: 90px;
            }
          }
        }
      }
    }
  }
  //
  .menu-right {
    position: fixed;
    bottom: 60px;
    right: 10px;
    list-style: none;
    padding: 0px;
    margin: 0px;
    display: block;
    background: $color-8;
    &__item {
      display: block;
      width: 100%;
      padding: 10px;
      &__link {
        display: flex;
        align-items: center;
        justify-content: center;
        text-decoration: none;
        flex-direction: column;
        padding: 5px;
        color: $color-1;
        &__text {
          display: block;
          margin-top: 5px;
          font-size: 12px;
          width: 80px; 
          white-space: nowrap;
          overflow: hidden; 
          text-overflow: ellipsis;
          text-align: center;
          text-transform: capitalize;
          @include desde($medium) {
            font-size: 14px;
          }
        }
      }
    }
  }
</style>